export enum InstructionDisplayMode {
  None = 0,
  TextAndImages = 1,
  VisualizationOfPlannedFlybar = 2
}

export default InstructionDisplayMode;
